/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageRewardDTO } from '../models/PageRewardDTO';
import type { RewardDTO } from '../models/RewardDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomRewardResourceService {
    /**
     * Marks as paid a reward
     * Partial updates of an existing reward
     * @returns RewardDTO OK
     * @throws ApiError
     */
    public static payReward({
        signallerId,
    }: {
        /**
         * The id of the signaller associated to the reward requested
         */
        signallerId: number,
    }): CancelablePromise<RewardDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/custom/reward/pay/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
        });
    }
    /**
     * Get the reward dto requested
     * Retrieves the reward dto requested
     * @returns RewardDTO OK
     * @throws ApiError
     */
    public static getReward1({
        rewardId,
    }: {
        /**
         * The id of the reward requested
         */
        rewardId: number,
    }): CancelablePromise<RewardDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/reward/{rewardId}',
            path: {
                'rewardId': rewardId,
            },
        });
    }
    /**
     * Get list of all rewards associated to the same signaller
     * Retrieves a paginated list of all rewards associated to the same signaller
     * @returns PageRewardDTO OK
     * @throws ApiError
     */
    public static getAllSignallerRewards({
        signallerId,
        page,
        size = 10,
        sortBy = 'dateCreate',
        sortDir = 'asc',
    }: {
        /**
         * The signaller ID to filter by
         */
        signallerId: number,
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageRewardDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/reward/signaller-rewards/{signallerId}',
            path: {
                'signallerId': signallerId,
            },
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteReward1({
        id,
    }: {
        /**
         * The id of the reward to delete
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/reward/deleteReward/{id}',
            path: {
                'id': id,
            },
        });
    }
}
